import { Component, OnInit } from '@angular/core';
import { ApiServiceERP } from 'src/app/web/apis/ApiServiceERP';
import { ErrorService } from 'src/app/shared/services/errors.service';
import jwt_decode from 'jwt-decode';
import { Token } from '@angular/compiler';

interface Permiso {
  exp: number;
  iat: number;
  id: number;
  id_user_erp: number;
  permisses: [];
  role_id: string;
  username: string;
}

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  public isCollapsed = true;
  public taas = true;
  public servicios = true;
  public proyectos = true;
  public clientes = true;
  public jefa = true;
  public ejecu = true;
  public finan = true;
  public admin = true;
  public roles = true;
  public excel = true;
  public avatar = "";
  public name = "";
  public token = "";
  public listPermis: Permiso;
  public permisos_menu: number[] = []
  proj = false;
  proj_list = false;
  proj_create = false;
  taa = false;
  taas_list = false;
  taas_create = false;
  serv = false;
  serv_list = false;
  serv_create = false;
  ejec = false;
  ejec_ubication = false;
  finance = false;
  finance_hes = false;
  leadership = false;
  leadership_payment = false
  customer = false;
  customer_list = false;
  customer_create = false;
  administration = false;
  administration_list_user = false;
  administration_project_etap = false;
  administration_cost = false;
  administration_asig = false;
  administration_leader = false;
  permissions_and_roles = false;
  permissions_and_roles_rol = false;
  permissions_and_roles_permissions = false;
  forecast = false;
  forecastDetail = false;
  paymentTrainPending = false;
  paymentTrainPendingDetail = false;
  forecastTrain = false;
  forecastTrainDetail = false;
  osm = false;
  generate_payroll_excel = false;

  constructor(
    private apiService: ApiServiceERP,
    private errorService: ErrorService,
  ) { }

  ngOnInit(): void {

    this.avatar = localStorage.getItem('avatar')
    this.name = localStorage.getItem('userName')
    this.token = localStorage.getItem('token')
    this.listPermis = jwt_decode(this.token);

    this.listPermis.permisses.map((dato) => {


      if (dato > 0) {


        if (this.permisos_menu.find(element => element == dato)) {

        } else {
          this.permisos_menu.push(Number(dato))
        }
      }

    });

    this.permisos_menu = this.permisos_menu.sort((a, b) => a - b);
    if (this.permisos_menu.find(element => element == 1)) {
      this.proj = true;
      if (this.permisos_menu.find(element => element == 2)) {
        this.proj_list = true;
      }
      if (this.permisos_menu.find(element => element == 3)) {
        this.proj_create = true;
      }
    }
    if (this.permisos_menu.find(element => element == 11)) {
      this.taa = true;
      if (this.permisos_menu.find(element => element == 12)) {
        this.taas_list = true;
      }
      if (this.permisos_menu.find(element => element == 13)) {
        this.taas_create = true;
      }
    }
    if (this.permisos_menu.find(element => element == 18)) {
      this.serv = true;
      if (this.permisos_menu.find(element => element == 19)) {
        this.serv_list = true;
      }
      if (this.permisos_menu.find(element => element == 20)) {
        this.serv_create = true;
      }
    }

    if (this.permisos_menu.find(element => element == 27)) {
      this.ejec = true;
      if (this.permisos_menu.find(element => element == 28)) {
        this.ejec_ubication = true;
      }
      if (this.permisos_menu.find(element => element == 49)) {
        this.osm = true;
      }
    }

    if (this.permisos_menu.find(element => element == 29)) {
      this.finance = true;
      if (this.permisos_menu.find(element => element == 30)) {
        this.finance_hes = true;
      }
      if (this.permisos_menu.find(element => element == 54)) {
        this.paymentTrainPending = true;
      }
      if (this.permisos_menu.find(element => element == 55)) {
        this.paymentTrainPendingDetail = true;
      }
    }
    if (this.permisos_menu.find(element => element == 31)) {
      this.leadership = true;
      if (this.permisos_menu.find(element => element == 32)) {
        this.leadership_payment = true;
      }
      if (this.permisos_menu.find(element => element == 48)) {
        this.forecast = true;
      }
      if (this.permisos_menu.find(element => element == 50)) {
        this.forecastDetail = true;
      }
      if (this.permisos_menu.find(element => element == 56)) {
        this.forecastTrain = true;
      }
      if (this.permisos_menu.find(element => element == 57)) {
        this.forecastTrainDetail = true;
      }
    }
    if (this.permisos_menu.find(element => element == 33)) {
      this.customer = true;
      if (this.permisos_menu.find(element => element == 34)) {
        this.customer_list = true;
      }
      if (this.permisos_menu.find(element => element == 35)) {
        this.customer_create = true;
      }
    }
    if (this.permisos_menu.find(element => element == 37)) {
      this.administration = true;

      if (this.permisos_menu.find(element => element == 44)) {
        this.administration_list_user = true;
      }
      if (this.permisos_menu.find(element => element == 38)) {
        this.administration_project_etap = true;
      }
      if (this.permisos_menu.find(element => element == 40)) {
        this.administration_cost = true;
      }
      if (this.permisos_menu.find(element => element == 42)) {
        this.administration_asig = true;
      }
      if (this.permisos_menu.find(element => element == 59)) {
        this.administration_leader = true;
      }
    }

    if (this.permisos_menu.find(element => element == 46)) {
      this.permissions_and_roles = true;
      if (this.permisos_menu.find(element => element == 46)) {
        this.permissions_and_roles_permissions = true;
      }
      if (this.permisos_menu.find(element => element == 47)) {
        this.permissions_and_roles_rol = true;
      }
    }
    if (this.permisos_menu.find(element => element == 58) || this.permisos_menu.find(element => element == 60)) {
      this.generate_payroll_excel = true;
    }
    
    // this.apiService.getService('list-user-roles?id='+ this.listPermis.id).subscribe({
    //   next: (rs: any) => {


    //   },
    //   error: (error) => {
    //     this.errorService.error(error)

    //     },
    // });

  }

  onclickSelect(info) {
    localStorage.removeItem('info-pdg-table')
    localStorage.removeItem('info-pdg-table-detail')
    if (info == "isCollapsed") {
      this.isCollapsed = false;
      this.taas = true;
      this.servicios = true;
      this.proyectos = true;
      this.clientes = true;
      this.jefa = true;
      this.ejecu = true;
      this.finan = true;
      this.admin = true;
      this.roles = true;
      this.excel = true;
    } else if (info == "taas") {
      this.isCollapsed = true;
      this.taas = false;
      this.servicios = true;
      this.proyectos = true;
      this.clientes = true;
      this.jefa = true;
      this.ejecu = true;
      this.finan = true;
      this.admin = true;
      this.roles = true;
      this.excel = true;
    } else if (info == "servicios") {
      this.isCollapsed = true;
      this.taas = true;
      this.servicios = false;
      this.proyectos = true;
      this.clientes = true;
      this.jefa = true;
      this.ejecu = true;
      this.finan = true;
      this.admin = true;
      this.roles = true;
      this.excel = true;
    } else if (info == "proyectos") {
      this.isCollapsed = true;
      this.taas = true;
      this.servicios = true;
      this.proyectos = false;
      this.clientes = true;
      this.jefa = true;
      this.ejecu = true;
      this.finan = true;
      this.admin = true;
      this.roles = true;
      this.excel = true;
    } else if (info == "clientes") {
      this.isCollapsed = true;
      this.taas = true;
      this.servicios = true;
      this.proyectos = true;
      this.clientes = false;
      this.jefa = true;
      this.ejecu = true;
      this.finan = true;
      this.admin = true;
      this.roles = true;
      this.excel = true;
    } else if (info == "jefa") {
      this.isCollapsed = true;
      this.taas = true;
      this.servicios = true;
      this.proyectos = true;
      this.clientes = true;
      this.jefa = false;
      this.ejecu = true;
      this.finan = true;
      this.admin = true;
      this.roles = true;
      this.excel = true;
    } else if (info == "ejecu") {
      this.isCollapsed = true;
      this.taas = true;
      this.servicios = true;
      this.proyectos = true;
      this.clientes = true;
      this.jefa = true;
      this.ejecu = false;
      this.finan = true;
      this.admin = true;
      this.roles = true;
      this.excel = true;
    } else if (info == "finan") {
      this.isCollapsed = true;
      this.taas = true;
      this.servicios = true;
      this.proyectos = true;
      this.clientes = true;
      this.jefa = true;
      this.ejecu = true;
      this.finan = false;
      this.admin = true;
      this.roles = true;
      this.excel = true;
    } else if (info == "admin") {
      this.isCollapsed = true;
      this.taas = true;
      this.servicios = true;
      this.proyectos = true;
      this.clientes = true;
      this.jefa = true;
      this.ejecu = true;
      this.finan = true;
      this.admin = false;
      this.roles = true;
      this.excel = true;
    } else if (info == "admin2") {
      this.isCollapsed = true;
      this.taas = true;
      this.servicios = true;
      this.proyectos = true;
      this.clientes = true;
      this.jefa = true;
      this.ejecu = true;
      this.finan = true;
      this.admin = true;
      this.roles = false;
      this.excel = true;
    } else if (info == "excel") {
      this.isCollapsed = true;
      this.taas = true;
      this.servicios = true;
      this.proyectos = true;
      this.clientes = true;
      this.jefa = true;
      this.ejecu = true;
      this.finan = true;
      this.admin = true;
      this.roles = true;
      this.excel = false;
    }

  }

}
